export default function sanitizeWithUnderscore(item) {
  if (item) {
    return item.replace(/\s+/g, '_');
  }
  return item;
}
